import { render, staticRenderFns } from "./ExportStast.vue?vue&type=template&id=65c13e1d&scoped=true"
import script from "./ExportStast.vue?vue&type=script&lang=js"
export * from "./ExportStast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c13e1d",
  null
  
)

export default component.exports